import { render, staticRenderFns } from "./SocialLinksMod.vue?vue&type=template&id=02c920dc"
import script from "./SocialLinksMod.vue?vue&type=script&lang=js"
export * from "./SocialLinksMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports